import script from "./vnc-password.vue?vue&type=script&lang=ts&setup=true"
export * from "./vnc-password.vue?vue&type=script&lang=ts&setup=true"

import "./vnc-password.vue?vue&type=style&index=0&id=78efef86&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78efef86"]])

export default __exports__